import React from 'react'
import '../assets/css/Toolbar.scss'

const Toolbar = (props) => {
    return <div className='toolbar'>{props.children}</div>
}

export default Toolbar
